import React from "react";
import { Container, Row, Col } from "reactstrap";
import heroImg from "../../../assests/images/hero-img2.png";
import Welcome from "../../../assests/images/Welcome.png";
import Slogan from "../../../assests/images/slogan.png";
import Chem from "../../../assests/images/chem.png";
import Phy from "../../../assests/images/phy.png";
import PastPaper from "../../../assests/images/pastpaper.png";
import { Box } from "@mui/material";
import "./hero-section.css";

const HeroSection = () => {
  return (
    <section className="hero_section">
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Row style={{ width: "100%" }}>
          <Col lg="6" md="12">
            <div className="hero__content">
              <div className="titleContainer">
                <img className="imgCont" src={Welcome} alt="Snow" />
                <h1 className="mb-4 hero__title">
                  Welcome!!! <br /> S2A <br />
                  Academy
                </h1>
              </div>

              <div className="imageContainer">
                <Box
                  component="img"
                  sx={{
                    width: "25rem",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                  src={Slogan}
                  alt="random"
                ></Box>
              </div>
            </div>
            <div className="logos">
              <Box
                component="img"
                sx={{
                  width: "190px",
                  height: "95px",
                  margin: "1rem",
                  objectFit: "cover",
                }}
                src={Chem}
                alt="random"
              ></Box>
              <Box
                component="img"
                sx={{
                  width: "170px",
                  height: "103px",
                  margin: "1rem",
                  objectFit: "cover",
                }}
                src={Phy}
              ></Box>
              <Box
                component="img"
                sx={{
                  width: "150px",
                  height: "140px",
                  marginLeft: "1rem",
                  objectFit: "cover",
                }}
                src={PastPaper}
                alt="random"
              ></Box>
            </div>
          </Col>

          <Col lg="6" md="12">
            <img src={heroImg} alt="" className="w-100 hero__img" />
            <h1 className="hero__subtitle1">Ushan Gunasekara</h1>
            <h1 className="hero__subtitle2">B.Sc. (Hons) in Chemistry</h1>
            <h1 className="mb-4 hero__subtitle3">
              University of Sri jayewardenepura
            </h1>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
